type AdherenceRingProps = {
  percentage: number
  label?: string
}

function adherenceStrokeColor(clamped: number): string {
  if (clamped >= 70) return '#4caf50'
  if (clamped >= 40) return '#f59e0b'
  return '#6b7280'
}

const AdherenceRing = ({ percentage, label = 'adherence' }: AdherenceRingProps) => {
  const radius = 20
  const circumference = 2 * Math.PI * radius
  const clamped = Math.min(100, Math.max(0, percentage))
  const offset = circumference - (clamped / 100) * circumference

  return (
    <div className="flex flex-col items-center gap-1">
      <svg width="48" height="48" viewBox="0 0 48 48" aria-hidden>
        <circle
          cx="24"
          cy="24"
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth="4"
          className="text-neutral-200 dark:text-neutral-800"
        />
        <circle
          cx="24"
          cy="24"
          r={radius}
          fill="none"
          stroke={adherenceStrokeColor(clamped)}
          strokeWidth="4"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform="rotate(-90 24 24)"
          style={{ transition: 'stroke-dashoffset 0.5s ease' }}
        />
        <text
          x="24"
          y="28"
          textAnchor="middle"
          fontSize="12"
          fontWeight="500"
          fill="currentColor"
          className="fill-neutral-900 dark:fill-neutral-100"
        >
          {Math.round(clamped)}%
        </text>
      </svg>
      <span className="text-[10px] uppercase tracking-wider text-neutral-500 dark:text-neutral-500">
        {label}
      </span>
    </div>
  )
}

export default AdherenceRing
